import { InternalSaleListingSchema } from '@fastre/core/schemas/saleListing'
import { Dispatch, SetStateAction, createContext, useContext } from 'react'

export const ListingContext = createContext<{
    listing: InternalSaleListingSchema
    setListing: Dispatch<SetStateAction<InternalSaleListingSchema>>
    refreshListing: () => Promise<void>
}>(undefined as any)
export const useListingContext = () => useContext(ListingContext)
